/**
 * EditMenu.jsx — Edit top-level menu.
 * Undo/Redo route through execCommand (works across all contentEditable
 * paragraphs). Find and Find & Replace dispatch custom events the
 * ManuscriptBody toolbar picks up. Commit Variable Changes fires an
 * event the Variables panel listens to.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownMenuSeparator, DropdownMenuShortcut } from '@/components/ui/dropdown-menu';
import { Menu, MenuItem } from './shared';

export function EditMenu() {
  const { t } = useTranslation();

  const undo = () => window.dispatchEvent(new CustomEvent('loom:edit-undo'));
  const redo = () => window.dispatchEvent(new CustomEvent('loom:edit-redo'));

  const find = () => window.dispatchEvent(new CustomEvent('loom:find-open'));
  const findReplace = () => window.dispatchEvent(new CustomEvent('loom:find-replace-open'));
  const commitVariables = () => window.dispatchEvent(new CustomEvent('loom:commit-variables'));

  return (
    <Menu label={t('menu.edit')}>
      <MenuItem onClick={undo} data-testid="menu-edit-undo">
        {t('menu.undo')}<DropdownMenuShortcut>Ctrl+Z</DropdownMenuShortcut>
      </MenuItem>
      <MenuItem onClick={redo} data-testid="menu-edit-redo">
        {t('menu.redo')}<DropdownMenuShortcut>Ctrl+Y</DropdownMenuShortcut>
      </MenuItem>
      <DropdownMenuSeparator />
      <MenuItem onClick={find} data-testid="menu-edit-find">
        {t('menu.find')}<DropdownMenuShortcut>Ctrl+F</DropdownMenuShortcut>
      </MenuItem>
      <MenuItem onClick={findReplace} data-testid="menu-edit-find-replace">
        {t('menu.findReplace')}<DropdownMenuShortcut>Ctrl+H</DropdownMenuShortcut>
      </MenuItem>
      <DropdownMenuSeparator />
      <MenuItem onClick={commitVariables} data-testid="menu-edit-commit-variables">
        {t('menu.commitVariableChanges')}
      </MenuItem>
    </Menu>
  );
}
